import { render, staticRenderFns } from "./CollaborationRegisterArrow.vue?vue&type=template&id=853187c6"
import script from "./CollaborationRegisterArrow.vue?vue&type=script&lang=js"
export * from "./CollaborationRegisterArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports